import { defineStore } from 'pinia'
import router from '@/router'
import { Setting } from '@/stores/setting.ts'
import { ExternalBaseSettingResponse, Setting as SystemSetting } from '@/api/system/setting.ts'

export type CommonState = {
    layoutRightIsLoading: boolean
    layoutRouteIsLoading: boolean
    pageGlobalIsLoading: boolean
    locale: string | 'zh-cn' | 'en'
    settingIsCached: boolean
    setting: Record<string, Setting>
    layoutRightIsLoadingMap: Record<string, boolean>
}
export const useCommonStore = defineStore('common', {
    state: (): CommonState => {
        return {
            layoutRightIsLoading: false,
            layoutRouteIsLoading: false,
            pageGlobalIsLoading: false,
            locale: 'zh-cn',
            settingIsCached: false,
            setting: {},
            layoutRightIsLoadingMap: {},
        }
    },
    actions: {
        async getBaseSetting(isForceRefresh?: boolean) {
            if (isForceRefresh) {
                this.settingIsCached = false
            }
            if (this.settingIsCached) {
                return this.setting
            }
            const settingArray = (await SystemSetting.externalBase()).data
            settingArray?.forEach((setting: ExternalBaseSettingResponse) => {
                if (setting.code) {
                    this.setting[setting.code] = setting
                }
            })
            this.setting['frontendFullVersion'] = {
                name: '前端版本',
                code: 'frontendFullVersion',
                value: __APP_INFO__.fullVersion,
                description: '前端版本',
            }
            this.settingIsCached = true
            return this.setting
        },
        async setLayoutRightIsLoading(isLoading: boolean) {
            const mapKey = router?.currentRoute?.value?.fullPath
            this.layoutRightIsLoadingMap[mapKey] = isLoading
        },
        async setLayoutRouteIsLoading(isLoading: boolean) {
            this.layoutRouteIsLoading = isLoading
        },
        async setPageGlobalIsLoading(isLoading: boolean) {
            this.pageGlobalIsLoading = isLoading
        },
        reset() {
            this.$reset()
        },
        setLocale(locale: string) {
            this.locale = locale
        },
        clear() {
            sessionStorage.removeItem('common')
        }
    },
    persist: {
        storage: sessionStorage,
    },
})
